import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@src/store';
import type { History } from '@src/types/shared/history';
import { nanoid } from 'nanoid';

type State = { histories: History[] };

const initialState: State = { histories: [] };

const resumeHistorySlice = createSlice({
  name: 'resumeHistory',
  initialState,
  reducers: {
    addHistory(state, action: PayloadAction<Omit<History, 'id'>>) {
      state.histories.push({ ...action.payload, id: nanoid() });
    },
    updateHistory(state, action: PayloadAction<{ index: number; item: History }>) {
      const { index, item } = action.payload;
      if (index >= 0 && index < state.histories.length) {
        state.histories[index] = item;
      }
    },
    updateHistoriesFromStorage(state, action: PayloadAction<History[]>) {
      state.histories = action.payload;
    },
    removeHistory(state, action: PayloadAction<number>) {
      state.histories.splice(action.payload, 1);
    },
    reorderHistories(state, action: PayloadAction<History[]>) {
      state.histories = action.payload;
    },
  },
});

export const {
  addHistory,
  updateHistory,
  updateHistoriesFromStorage,
  removeHistory,
  reorderHistories,
} = resumeHistorySlice.actions;

export const selectHistory = (state: RootState): History[] => state.resumeHistory.histories;

export default resumeHistorySlice.reducer;
